import { css, styled } from 'styled-components'
import { motion, MotionProps } from 'framer-motion'
import { COLORS } from 'consts/colors'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { DROPDOWN_Z_INDEX } from 'consts/zIndex'

export const UserDropdownWrapper = styled.div``

export const UserDropdownOverlay = styled(motion.div)<MotionProps>`
  position: fixed;
  z-index: ${DROPDOWN_Z_INDEX};
  top: 60px;
  right: 28px;
  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    top: 64px;
    left: 0;
    bottom: 0;
    width: 100%;
    height: calc(100% - 64px);
    background-color: rgba(0, 0, 0, 0.5);
  }
`

interface IUserDropdownProps extends MotionProps {
  isOpen: boolean
}

export const UserDropdown = styled(motion.div)<IUserDropdownProps>`
  width: 250px;
  max-height: 472px;
  overflow-y: auto;
  border-radius: 8px;
  background-color: ${COLORS.white};
  box-shadow: 0px 0px 12px rgba(27, 85, 216, 0.16);
  display: none;
  z-index: ${DROPDOWN_Z_INDEX + 1};
  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    position: absolute;
    max-height: initial;
    height: 100%;
    border-radius: 0;
    right: 0;
    top: 0;
    box-shadow: none;
  }
  ${({ isOpen }) =>
    isOpen &&
    css`
      display: block;
    `}
`

export const UserDropdownContent = styled.div`
  width: 250px;
`

export const UserDropdownHeader = styled.div<{ $isDropdownOpen: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  cursor: pointer;

  svg {
    transition: transform 0.3s ease-in-out;
    fill: ${COLORS.secondaryExtraDark};
  }
  ${({ $isDropdownOpen }) =>
    $isDropdownOpen &&
    css`
      svg {
        transform: rotate(180deg);
      }
    `}
`

export const BurgerButton = styled.div<{ $isOpen: boolean }>`
  width: 40px;
  height: 40px;
  position: relative;
  cursor: pointer;
  border: none;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: -8px;
    width: 1px;
    height: 24px;
    top: 10px;
    bottom: 2px;
    background-color: ${COLORS.borderColor};
  }
  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    display: block;
  }

  & > div {
    position: absolute;
    left: 8px;
    width: 24px;
    height: 3px;
    background-color: ${COLORS.secondarySemiDark};
    border-radius: 5px;
    transition: all 0.2s;
  }

  & > div:nth-child(1) {
    top: 15px;
  }
  & > div:nth-child(2) {
    top: 25px;
  }

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      & > div:nth-child(1) {
        top: 21px;
        transform: rotateZ(45deg);
      }
      & > div:nth-child(2) {
        top: 21px;
        transform: rotateZ(-45deg);
      }
    `}
`
